import { z } from "zod";
import { workspaceFileSchema, workspaceFileLinkTargetSchema, workspaceFileVisibilitySchema } from "./channels.js";
const id = z.string().trim().min(1).max(200);
export const twinFileTargetSchema = z.object({
    targetType: workspaceFileLinkTargetSchema,
    targetId: id,
}).strict();
export const twinFilesListQuerySchema = z.object({
    fileId: id.optional(),
    q: z.string().trim().min(1).max(200).optional(),
    targetType: workspaceFileLinkTargetSchema.optional(),
    targetId: id.optional(),
    cursor: z.string().trim().min(1).max(2048).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(100),
}).strict().refine(value => Boolean(value.targetType) === Boolean(value.targetId), {
    message: "targetType and targetId must be supplied together.",
});
export const twinFileResponseSchema = z.object({ file: workspaceFileSchema, attached: z.boolean().optional() }).strict();
export const twinFileUploadMetadataSchema = z.object({
    channelId: id.optional(),
    sessionId: id.optional(),
    recordId: id.optional(),
    visibility: workspaceFileVisibilitySchema.optional(),
}).strict();
/** Keeps binary MCP inputs comfortably within the normal gateway JSON budget. */
export const TWIN_FILE_INLINE_MAX_BYTES = 32 * 1024;
export const twinFileInlineUploadInputSchema = twinFileUploadMetadataSchema.extend({
    fileName: z.string().trim().min(1).max(180),
    contentType: z.string().trim().min(1).max(200).default("application/octet-stream"),
    contentBase64: z.string().max(Math.ceil(TWIN_FILE_INLINE_MAX_BYTES / 3) * 4)
        .regex(/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/u),
});
export const twinFileUploadTransportSchema = z.object({
    uploadUrl: z.string().url(),
    method: z.literal("POST"),
    contentType: z.literal("multipart/form-data"),
    fileField: z.literal("file"),
    maxBytes: z.number().int().positive(),
    fields: twinFileUploadMetadataSchema,
    authentication: z.literal("Use the same OAuth bearer token or MLX subject token as this request."),
    uploaded: z.literal(false),
}).strict();
